<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
    >
        <path
            d="M8.33888 1.05332L14.1722 2.91999C14.6322 3.06777 14.9444 3.49555 14.9444 3.97777V11.2222C14.9444 14.5889 9.73999 16.4978 8.34221 16.95C8.11665 17.0233 7.88332 17.0233 7.65776 16.95C6.25999 16.4978 1.05554 14.5889 1.05554 11.2222V3.97777C1.05554 3.49444 1.36776 3.06666 1.82776 2.91999L7.6611 1.05332C7.8811 0.983324 8.11776 0.983324 8.33888 1.05332Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
